export default __webpack_public_path__ + "static/media/logo2.ce33b23d.png";